import Grid from '@mui/material/Unstable_Grid2';
import { Button, TextField } from '@mui/material';
import { Key } from '@mui/icons-material';
import { useAuth, useProvideSnackBar } from '../../hooks';

interface CreateOrShowKeycloakUserProps {
    uuid: string;
    keycloakUserId: string | undefined;
    keycloakUsername: string | undefined;
    onSuccess: () => Promise<void>;
}

const CreateOrShowKeycloakUser = ({ uuid, keycloakUserId, keycloakUsername, onSuccess }: CreateOrShowKeycloakUserProps) => {
    const { showError, showSuccess, showResponseError } = useProvideSnackBar();
    const { user } = useAuth();

    const createKeycloakUser = async () => {
        try {
            const response = await fetch(`/api/v1/contractor/${uuid}/create_keycloak_user`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${user?.accessToken}`,
                },
            });

            if (response.ok) {
                showSuccess('Az adatok sikeresen frissítve lettek!');
                await onSuccess();
            } else {
                await showResponseError(response, true);
            }
        } catch (error: any) {
            showError(`Hiba történt az adat frissítése közben`);
        }
    };

    return (
        <Grid container>
            {!keycloakUserId ? (
                <Button fullWidth sx={{ my: 2, px: 2 }} variant={'outlined'} color='primary' size={'medium'} startIcon={<Key />} onClick={createKeycloakUser}>
                    Keycloak felhasználó létrehozása
                </Button>
            ) : (
                <Grid xs={12} container flexDirection={'row'} mt={2} mb={2}>
                    <Grid xs={6}>
                        <TextField label='Keycloak felhasználónév' variant='standard' fullWidth value={keycloakUsername} InputProps={{ readOnly: true }} />
                    </Grid>
                    <Grid xs={6}>
                        <TextField label='Keycloak id' variant='standard' fullWidth value={keycloakUserId} InputProps={{ readOnly: true }} />
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
};

export default CreateOrShowKeycloakUser;